<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<item-class-group v-model="group_code" :headers="headers" />
					<item-class-category v-model="category_code" />
					<item-department-a v-model="deptA" />
					<item-department-b v-model="deptB" />
				</p>
				<p class="mgb_5">
					<span class="int_type_no_border mgr_5">
						<item-class-select-multi-s :key="item_class_component_key" :multiSelect="true" :syncWithString="true" :hideClassesString="true" v-model="item_classes_string" />
					</span>
					<ItemClassKeywordSearch @setClassList="addSearchingItemClasses" :customPlaceholder="`Search by Item ${headers.class} Code Starting with Keyword`" />
				</p>

				<p>
					<ItemClassRange :btnTitle="'Search by Range'" @input="addSearchingItemClasses" />
				</p>

				<p class="mgb_5">
					<em class="lt_text">Selected Item {{ headers.class }}</em>
					<textarea rows="3" v-model.trim="item_classes_string" class="textarea_type" style="display:inline-block; vertical-align:middle; width: 70%;" @focus="$event.target.select()" @input="item_class_component_key++" />
				</p>
				<SelectUserDefinedGroup v-model="user_defined_group" ref="user_defined_group" :display-all="false" />
				<br />
				<span class="mgr_15">
					<input type="radio" id="All" value="A" v-model="type" />
					<label for="All">All</label>
					<input type="radio" id="current" value="N" v-model="type" />
					<label for="current">Current Inventory</label>
					<input type="radio" id="close" value="Y" v-model="type" />
					<label for="close">Close Out</label>
				</span>
				<span class="mgr_15">
					<em>Qty</em>
					<span class="int_type sssm_int"><input type="number" class="sm_int al_right" v-model.trim="start_qty"/></span>
					~
					<span class="int_type sssm_int"><input type="number" class="sm_int al_right" v-model.trim="end_qty"/></span>
				</span>
				<span class="mgr_15">
					<input type="checkbox" v-model="zero_yn" id="zero_yn" value="Y" />
					<label for="zero_yn">Zero Qty Stock Only</label>
				</span>
				<span v-if="isNewjigu">
					<label>
						<input
							type="checkbox"
							v-model="is_sales_status"
							@change="
								() => {
									setHeader();
									tbl_key++;
								}
							"
						/>
						<em>Sales Status</em>
					</label>
				</span>
				<br />
				<span>
					<em>Item Color</em>
					<span class="int_type half_int">
						<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" />
					</span>
				</span>
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<CommonTable :key="tbl_key" :tbl_headers="tbl_headers" :data="display_records" @onOrderClick="onOrderClick" @onColorClick="onColorClick" @onAvailClick="onAvailClick" @onPendingClick="onPendingClick" />

		<div style="text-align:right;padding-right:10px;">
			<span v-if="cost_viewable && (items.total_value || items.total_value === 0)" class="mgr_15">Total Value : $ {{ items.total_value | toCurrency }}</span>
			<span v-if="items.count || items.count === 0">Total Count : {{ items.count | commaSeparated }}</span>
		</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage" />

		<div class="view_bottom_bt" style="overflow-y: hidden;">
			<div class="mgb_10">
				<span class="int_type_no_border mgr_15">
					<PageSizeSelect v-model="page_size" @input="isEmpty(copyParam) ? null : search()" />
				</span>
				<a href="javascript:void(0);" type="button" class="search_bt" @click="excel">Excel</a>
				<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Print Type Excel</a>
				<a href="javascript:void(0);" type="button" class="search_bt" @click="print">Print</a>
			</div>
			<div v-if="cost_viewable" style="clear: both;">
				<label v-if="fob_price_view" class="right_option"><input type="checkbox" :disabled="!include_cost" v-model="include_last_sh_price" /> Print Including LastShip P.</label>
				<label class="right_option mgr_10"><input type="checkbox" v-model="include_cost" /> Print Including Cost Info.</label>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'POStatus'" :draggable="false" @keydown.esc.prevent="test()">
			<template slot="title">PO Status</template>
			<template slot="body">
				<POStatusPopup :item_id="item_id" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'PreemtedSO'" :draggable="false">
			<template slot="title">Preempted SO(s)</template>
			<template slot="body">
				<PreemptedSoPopup :item_id="selectedItemId" :pending_90="pending_90" v-on:close="closeModal()" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';

import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import ItemClassCategory from '@/components/common/ItemClassCategory.vue';
import ItemDepartmentA from '@/components/common/ItemDepartmentA';
import ItemDepartmentB from '@/components/common/ItemDepartmentB';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import ItemClassGroup from '@/components/common/ItemClassGroup';
import ItemClassKeywordSearch from '@/components/common/ItemClassKeywordSearch';
import ItemClassRange from '@/components/common/ItemClassRange';
import SelectUserDefinedGroup from '@/components/common/SelectUserDefinedGroup';
import Modal from '@/components/common/Modal';
import POStatusPopup from '@/components/common/POStatusPopup';
import PreemptedSoPopup from '@/components/common/PreemptedSoPopup';

import { apiInventoryStatus, apiInventoryStatusRawData } from '@/api/item/master.js';
import { exportDataExcel, apiGetReportTemplate, exportFile, isEmpty, objectCopy, objectToUrlParam, Report, reportMrtUrl, companyMrtUrl, PrintType } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,

			colors_string: '',

			deptA: '',
			deptB: '',
			category_code: '',
			group_code: '',
			user_defined_group: '',
			start_qty: '',
			end_qty: '',
			zero_yn: false,
			items: {
				list: [],
			},
			type: 'A',
			copyParam: {},

			separator: ',',
			item_classes_string: '',
			item_class_component_key: 0,

			include_cost: true, // minkhair만 적용
			include_last_sh_price: true,

			display_records: [],
			tbl_headers: [],

			is_sales_status: false,
			tbl_key: 0,

			showModal: false,
			modalName: null,
			item_id: null,
			pending_90: null,
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		isMinkHair() {
			return this.company_id === 'minkhair';
		},
		isNewjigu() {
			return this.company_id === 'newjigu';
		},
		excel_export_raw_data() {
			return !['beautyplus', 'hairplus'].includes(this.company_id);
		},
		cost_viewable() {
			return this.user && this.user.cost_view_yn === 'Y';
		},
		fob_price_view() {
			return this.user && this.user.fob_price_view;
		},
		itemClasses() {
			let res = [];

			if (this.item_classes_string) {
				this.item_classes_string.split(this.separator).forEach(el => {
					if (!res.some(e => e === el)) res.push(el);
				});
			}

			return res;
		},
		user_defined_group_list() {
			return this.user_defined_group.split('|');
		},
	},
	components: {
		CommonTable,
		Paging,
		ItemClassSelectMultiS,
		ItemClassCategory,
		ItemDepartmentA,
		ItemDepartmentB,
		ItemClassGroup,
		SelectUserDefinedGroup,
		ItemClassKeywordSearch,
		ItemClassRange,
		PageSizeSelect,
		Modal,
		POStatusPopup,
		PreemptedSoPopup,
	},
	methods: {
		isEmpty,
		row(group, cls, item) {
			let record = {};
			this.setValue(group, record);
			this.setValue(cls, record);
			this.setValue(item, record);
			return record;
		},
		setValue: function(item, record) {
			if (item) for (let key of Object.keys(item)) if ('list' !== key) record[key] = item[key];
		},
		onOrderClick(item) {
			// let routeData = this.$router.resolve({ name: 'onOrderDetail', query: { backUri: this.uri, class_code: item.class_code } });
			// window.open(routeData.href, 'herp_on_order_detail');
			this.item_id = item.item_id;
			this.modalName = 'POStatus';
			this.showModal = true;
		},
		onColorClick(item) {
			let routeData = this.$router.resolve({ name: 'salesGoods', query: { backUri: this.uri, class_code: item.class_code, color_code: item.color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		onAvailClick(item) {
			if (this.user.preempted_so_view) {
				this.selectedItemId = item.item_id;
				this.pending_90 = null;
				this.modalName = 'PreemtedSO';
				this.showModal = true;
			}
		},
		onPendingClick(item) {
			if (this.user.preempted_so_view) {
				this.selectedItemId = item.item_id;
				this.pending_90 = true;
				this.modalName = 'PreemtedSO';
				this.showModal = true;
			}
		},
		closeModal() {
			this.showModal = false;
		},
		makeDisplayData(root) {
			let records = [];

			if (root.list.length > 0) {
				root.list.forEach(group => {
					group.list.forEach((cls, clsIndex) => {
						if (cls && Array.isArray(cls.list)) {
							cls.list.forEach((item, itemIndex) => {
								const group_param = clsIndex == 0 && itemIndex == 0 ? group : undefined;
								const class_param = this.isNewjigu || itemIndex == 0 ? cls : undefined;
								const rec = this.row(group_param, class_param, item);
								rec.cell_style = { available_quantity: [rec.available_quantity > 0 ? 'blue_letter' : 'red_letter', 'bold_letter'] };
								records.push(rec);
							});
						} else {
							records.push(this.row(clsIndex == 0 ? group : undefined, cls));
						}
					});
				});
			}
			return records;
		},
		addSearchingItemClasses(itemClassList) {
			if (!itemClassList || !itemClassList.length) return;
			this.item_classes_string = itemClassList.map(cls => cls.code).join(this.separator);
			this.item_class_component_key++;

			this.search();
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectItemList(pageNo);
		},
		reset() {
			this.colors_string = '';
			this.group_code = '';
			this.category_code = '';
			this.deptA = '';
			this.deptB = '';
			this.item_classes_string = '';
			this.start_qty = '';
			this.end_qty = '';
			this.zero_yn = false;
			this.type = 'A';
			this.user_defined_group = '';

			this.item_class_component_key++;
		},
		search() {
			this.selectItemList();
		},
		async selectItemList(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			const param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				color_codes: this.colors_string,
				group_code: this.group_code,
				category_code: this.category_code,
				item_classes: this.itemClasses,
				deptA: this.deptA,
				deptB: this.deptB,
				start_qty: this.start_qty,
				end_qty: this.end_qty,
				zero_yn: this.zero_yn === true ? 'Y' : 'N',
				type: this.type,
				user_defined_group: this.user_defined_group_list,
				include_back_order: this.isNewjigu,
			};

			const copyParam = {
				color_codes: this.colors_string,
				group_code: this.group_code,
				category_code: this.category_code,
				item_classes: this.itemClasses,
				deptA: this.deptA,
				deptB: this.deptB,
				start_qty: this.start_qty,
				end_qty: this.end_qty,
				zero_yn: this.zero_yn === true ? 'Y' : 'N',
				type: this.type,
				paging_yn: 'N',
				user_defined_group: this.user_defined_group_list,
				include_back_order: this.isNewjigu,
			};
			if (this.cost_viewable && this.fob_price_view) {
				param.last_sh_price_with_modification_reflected = true;
				copyParam.last_sh_price_with_modification_reflected = true;
			}

			this.copyParam = objectCopy(copyParam);
			const { data } = await apiInventoryStatus(objectToUrlParam(param));

			this.items = data.value;
			this.count = data.value.count;
			this.display_records = this.makeDisplayData(this.items);

			this.$refs.paging.setPage(this.page_no, this.page_size, this.items.count);
		},

		// Class Group을 사용하지 않음.
		// root: { .., (Group)list: [ { (Class)list: [ { ...Class, (Item)list: [ ...Item] }, {}, {}, .. ] } ] }
		sortByClassCode(root) {
			const root_list = [];
			const root_list_0 = {
				group_code: null,
				group_name: null,
				list: [],
			};
			root_list.push(root_list_0);

			if (Array.isArray(root.list)) {
				root.list.forEach(group => {
					if (Array.isArray(group.list)) {
						group.list.forEach(cls => root_list_0.list.push(cls));
					}
				});
			}

			root_list_0.list.sort();
			return root_list;
		},

		getBeginClassColor(root) {
			const first_group = Array.isArray(root.list) && root.list.length ? root.list[0] : null;
			const first_class = first_group && Array.isArray(first_group.list) && first_group.list.length ? first_group.list[0] : null;
			const first_color = first_class && Array.isArray(first_class.list) && first_class.list.length ? first_class.list[0] : null;

			return (first_class ? first_class.class_code : '') + '_' + (first_color ? first_color.color_code : '');
		},
		getEndClassColor(root) {
			const last_group = Array.isArray(root.list) && root.list.length ? root.list[root.list.length - 1] : null;
			const last_class = last_group && Array.isArray(last_group.list) && last_group.list.length ? last_group.list[last_group.list.length - 1] : null;
			const last_color = last_class && Array.isArray(last_class.list) && last_class.list.length ? last_class.list[last_class.list.length - 1] : null;

			return (last_class ? last_class.class_code : '') + '_' + (last_color ? last_color.color_code : '');
		},
		setReportParamForMinkHair(root) {
			root.list = this.sortByClassCode(root);
			// root.cost_view_yn = this.cost_viewable && this.include_cost ? 'Y' : 'N';
			root.print_dt = this.$moment(new Date()).format('MM/DD/YYYY HH:mm');
			root.print_user = this.user.user_id;
			root.begin_class_color = this.getBeginClassColor(root);
			root.end_class_color = this.getEndClassColor(root);
		},
		async getReportObject(is_excel) {
			let reportTemplate = null;
			let reportWidth;
			const { data } = await apiInventoryStatus(objectToUrlParam(this.copyParam));
			data.value.is_excel = is_excel;
			data.value.cost_view_yn = this.cost_viewable && this.include_cost ? 'Y' : 'N';

			if (this.user.company_id === 'minkhair') {
				this.setReportParamForMinkHair(data.value);
				reportTemplate = await apiGetReportTemplate('inventoryStatus', companyMrtUrl('inventoryStatus'));
				if (!is_excel) reportWidth = 70;
			} else {
				reportTemplate = await apiGetReportTemplate('inventoryStatus', reportMrtUrl('inventoryStatus'));
			}

			return new Report(reportTemplate, data.value, 'inventoryStatus', PrintType.Normal, false, false, null, reportWidth);
		},

		async exportExcel() {
			if (isEmpty(this.copyParam)) {
				this.$toast.error('Please search first');
				return false;
			}

			const report = await this.getReportObject(true);
			exportFile(report, 'excel');
		},

		async print() {
			if (isEmpty(this.copyParam)) {
				this.$toast.error('Please search first');
				return false;
			}

			const report = await this.getReportObject(false);
			this.$store.commit('setReport', report);
		},

		async excel() {
			if (isEmpty(this.copyParam)) {
				this.$toast.error('Please search first');
				return false;
			}

			let result = null;
			let fileName = null;
			let headers = null;
			if (this.excel_export_raw_data) {
				const { data } = await apiInventoryStatusRawData(objectToUrlParam(this.copyParam));
				result = data;
			} else {
				const { data } = await apiInventoryStatus(objectToUrlParam(this.copyParam));
				result = this.makeDisplayData(data.value);
			}

			let cost_viewable = this.cost_viewable && this.include_cost;
			let include_last_sh_price = this.fob_price_view && this.include_last_sh_price;

			if (this.is_sales_status) {
				fileName = 'InventorySalesStatus';
				headers = [
					{ key: 'class_code', name: this.headers.class + ' Code', width: 15, dataType: defaultDataType.string },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
					//{ key: 'class_name', name: this.headers.class + ' Name', width: 25, dataType: defaultDataType.string },
					{ key: 'min_price', name: 'M.Price', width: 10, dataType: defaultDataType.number },
					{ key: 'available_quantity', name: 'Avail', width: 10, dataType: defaultDataType.currency },
					{ key: 'total_bo_quantity', name: 'B/O', width: 10, dataType: defaultDataType.currency },
					{ key: 'on_board_quantity', name: 'On Board', width: 10, dataType: defaultDataType.currency },
					{ key: 'po_quantity', name: 'On Order', width: 10, dataType: defaultDataType.currency },
					// { key: 'total_quantity', name: 'Avail + On Board + On Order', width: 20, dataType: defaultDataType.currency },
					{ key: 'total_quantity', name: 'Avail + On Order', width: 20, dataType: defaultDataType.currency },
					{ key: 'pending_30_quantity', name: 'Pend30', width: 10, dataType: defaultDataType.currency },
					{ key: 'avg_5ms_quantity', name: '5M Avg', width: 10, dataType: defaultDataType.currency },
					{ key: 'thisMonthSales', name: 'C Month', width: 10, dataType: defaultDataType.currency },
					{ key: 'ms1', name: '1M', width: 10, dataType: defaultDataType.currency },
					{ key: 'ms2', name: '2M', width: 10, dataType: defaultDataType.currency },
					{ key: 'ms3', name: '3M', width: 10, dataType: defaultDataType.currency },
					{ key: 'ms4', name: '4M', width: 10, dataType: defaultDataType.currency },
					{ key: 'ms5', name: '5M', width: 10, dataType: defaultDataType.currency },
					{ key: 'arrival_date', name: 'Arr Date', width: 15, dataType: defaultDataType.string },
				];

				let idx = headers.findIndex(h => h.key === 'min_price');
				if (this.user.company_id == 'newjigu') headers.splice(idx, 0, { key: 'item_name', name: 'Item Name', width: 45, dataType: defaultDataType.string });
				else headers.splice(idx, 0, { key: 'class_name', name: this.headers.class + ' Name', width: 10, dataType: defaultDataType.string });

				if (this.user.company_id == 'newjigu') {
					let idx = headers.findIndex(h => h.key === 'available_quantity');
					headers.splice(idx, 0, { key: 'b_price', name: 'B.Price', width: 10, dataType: defaultDataType.number });

					headers.splice(0, 0, { key: 'group_name', name: this.headers.class + ' Group', width: 15, dataType: defaultDataType.string });
				}

				if (cost_viewable) {
					let idx = headers.findIndex(h => h.key === 'available_quantity');
					headers.splice(idx, 0, { key: 'cost', name: this.user.company_id === 'minkhair' ? 'Avg Cost' : 'Cost', width: 10, dataType: defaultDataType.number });
				}
			} else {
				fileName = 'InventoryStatus' + (this.isNewjigu && this.copyParam && this.copyParam.group_code ? '_' + this.copyParam.group_code : '');
				headers = [
					{ key: 'group_name', name: `${this.headers.class} Group`, width: 15, dataType: defaultDataType.string },
					{ key: 'class_code', name: `${this.headers.class} Code`, width: 15, dataType: defaultDataType.string },
					{ key: 'class_name', name: `${this.headers.class} Name`, width: 15, dataType: defaultDataType.string },
					{ key: 'item_name', name: 'Item Name', width: 15, dataType: defaultDataType.string },
					{ key: 'item_code', name: 'Item Code', width: 15, dataType: defaultDataType.string },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
					{ key: 'min_price', name: 'M.Price', width: 15, dataType: defaultDataType.number },
					{ key: 'on_hand', name: 'On Hand', width: 15, dataType: defaultDataType.currency },
					{ key: 'available_quantity', name: 'Avail', width: 15, dataType: defaultDataType.currency },
					{ key: 'avg_3ms_quantity', name: '3M Avg', width: 15, dataType: defaultDataType.currency },
					{ key: 'po_quantity', name: 'On Order', width: 15, dataType: defaultDataType.currency },
					{ key: 'on_board_quantity', name: 'On Board', width: 15, dataType: defaultDataType.currency },
					{ key: 'arrival_date', name: 'Arr Date', width: 15, dataType: defaultDataType.string },
				];

				if (cost_viewable) {
					if (this.user.company_id === 'newjigu') {
						headers.push({ key: 'cost', name: 'Cost', width: 15, dataType: defaultDataType.number });
						headers.push({ key: 'last_sh_price', name: 'LastShip P.', width: 15, dataType: defaultDataType.number });
						headers.push({ key: 'item_total_value', name: 'Total Val.', width: 15, dataType: defaultDataType.number });
					} else {
						let idx = headers.findIndex(h => h.key === 'on_hand'); // on_hand컬럼 뒤에 위치시킴.
						headers.splice(++idx, 0, { key: 'cost', name: this.user.company_id === 'minkhair' ? 'Avg Cost' : 'Cost', width: 15, dataType: defaultDataType.number });
						if (include_last_sh_price) headers.splice(++idx, 0, { key: 'last_sh_price', name: 'LastShip P.', width: 15, dataType: defaultDataType.number });
						headers.splice(++idx, 0, { key: 'item_total_value', name: 'Total Val.', width: 15, dataType: defaultDataType.number });
					}
				}

				if (this.user.company_id === 'newjigu') {
					headers.push({ key: 'barcode', name: 'Barcode', width: 15, dataType: defaultDataType.string });

					let idx = headers.findIndex(h => h.key === 'class_name'); // style name 삭제
					headers.splice(idx, 1);
					idx = headers.findIndex(h => h.key === 'min_price');
					headers.splice(
						idx,
						1,
						{ key: 'a_price', name: 'A.Price', width: 15, dataType: defaultDataType.number },
						{ key: 'b_price', name: 'B.Price', width: 15, dataType: defaultDataType.number },
						{ key: 'c_price', name: 'C.Price', width: 15, dataType: defaultDataType.number },
						{ key: 'packing', name: 'Pcs(Box)', width: 15, dataType: defaultDataType.currency },
					);

					idx = headers.findIndex(h => h.key === 'avg_3ms_quantity');
					headers.splice(idx, 0, { key: 'pending_90_quantity', name: 'Pend90', width: 10, dataType: defaultDataType.currency });
					headers.splice(idx, 0, { key: 'pending_30_quantity', name: 'Pend30', width: 10, dataType: defaultDataType.currency });
				}
			}

			exportDataExcel(result, headers, fileName);
		},
		defaultHeader() {
			const header = [
				{ key: 'group_name', name: this.headers.class + ' Group', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'group_name' } },
				{ key: 'category_code', name: this.headers.class + ' Category', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'category_code' } },
				{ key: 'dept_a_code', name: 'Dept.A', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'dept_a_code' } },
				{ key: 'class_code', name: this.headers.class + ' Code', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'class_code' } },
				{ key: 'class_name', name: this.headers.class + ' Name', td_class: ['al_left', 'truncate'], title: { prop: 'class_name' } },
				{ key: 'item_code', name: 'Item Code', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'item_code' } },
				{ key: 'color_code', name: 'Color', tbl_width: '100px', td_class: ['al_center', 'truncate'], title: { prop: 'color_code' } },
				{ key: 'min_price', name: 'M.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'on_hand', name: 'On Hand', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'available_quantity', name: 'Avail', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'avg_3ms_quantity', name: '3M Avg', tbl_width: '60px', td_class: ['al_right', 'red_letter'], display_filter: 'commaSeparated' },
				{ key: 'cost', name: 'Cost', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'last_sh_price', name: 'LastShip P.', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !(this.cost_viewable && this.fob_price_view) },
				{ key: 'item_total_value', name: 'Total Val.', tbl_width: '80px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'po_quantity', name: 'On Order', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'on_board_quantity', name: 'On Board', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'arrival_date', name: 'Arr Date', tbl_width: '80px', td_class: ['al_left'] },
			];

			return header;
		},
		minkhairHeader() {
			const header = [
				{ key: 'group_name', name: this.headers.class + ' Group', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'group_name' } },
				{ key: 'category_code', name: this.headers.class + ' Category', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'category_code' } },
				{ key: 'dept_a_code', name: 'Dept.A', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'dept_a_code' } },
				{ key: 'class_code', name: this.headers.class + ' Code', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'class_code' } },
				{ key: 'class_name', name: this.headers.class + ' Name', td_class: ['al_left', 'truncate'], title: { prop: 'class_name' } },
				{ key: 'item_code', name: 'Item Code', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'item_code' } },
				{ key: 'color_code', name: 'Color', tbl_width: '100px', td_class: ['al_center', 'truncate'], title: { prop: 'color_code' } },
				{ key: 'min_price', name: 'M.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'on_hand', name: 'On Hand', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'available_quantity', name: 'Avail', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'avg_3ms_quantity', name: '3M Avg', tbl_width: '60px', td_class: ['al_right', 'red_letter'], display_filter: 'commaSeparated' },
				{ key: 'cost', name: 'Avg Cost', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'last_sh_price', name: 'LastShip P.', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !(this.cost_viewable && this.fob_price_view) },
				{ key: 'item_total_value', name: 'Total Val.', tbl_width: '80px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'po_quantity', name: 'On Order', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'on_board_quantity', name: 'On Board', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'arrival_date', name: 'Arr Date', tbl_width: '80px', td_class: ['al_left'] },
			];

			return header;
		},
		newjiguHeader() {
			const header = [
				{ key: 'group_name', name: this.headers.class + ' Group', tbl_width: '90px', td_class: ['al_left', 'truncate'], title: { prop: 'group_name' } },
				{ key: 'category_code', name: this.headers.class + ' Category', tbl_width: '100px', td_class: ['al_left', 'truncate'], title: { prop: 'category_code' } },
				{ key: 'class_code', name: this.headers.class + ' Code', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'class_code' } },
				{ key: 'item_name', name: 'Item Name', td_class: ['al_left'], title: { prop: 'item_name' } },
				{ key: 'color_code', name: 'Color', tbl_width: '100px', td_class: ['al_center', 'truncate'], title: { prop: 'color_code' }, click_event: 'onColorClick' },
				{ key: 'a_price', name: 'A.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'b_price', name: 'B.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'c_price', name: 'C.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'packing', name: 'Pcs(Box)', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'on_hand', name: 'On Hand', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'available_quantity', name: 'Avail', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated', click_event: 'onAvailClick' },
				{ key: 'pending_30_quantity', name: 'Pend30', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'pending_90_quantity', name: 'Pend90', tbl_width: '50px', td_class: ['al_right'], display_filter: 'commaSeparated', click_event: 'onPendingClick' },
				{ key: 'avg_3ms_quantity', name: '3M Avg', tbl_width: '60px', td_class: ['al_right', 'red_letter'], display_filter: 'commaSeparated' },
				{ key: 'cost', name: 'Cost', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'last_sh_price', name: 'LastShip P.', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !(this.cost_viewable && this.fob_price_view) },
				{ key: 'item_total_value', name: 'Total Val.', tbl_width: '80px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'po_quantity', name: 'On Order', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated', click_event: 'onOrderClick' },
				{ key: 'on_board_quantity', name: 'On Board', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'arrival_date', name: 'Arr Date', tbl_width: '80px', td_class: ['al_left'] },
			];

			return header;
		},
		salesStatusHeader() {
			const header = [
				{ key: 'class_code', name: this.headers.class + ' Code', tbl_width: '120px', td_class: ['al_left', 'truncate'], title: { prop: 'class_code' } },
				{ key: 'color_code', name: 'Color', tbl_width: '100px', td_class: ['al_center', 'truncate'], title: { prop: 'color_code' } },
				{ key: 'item_name', name: 'Item Name', td_class: ['al_left'], title: { prop: 'item_name' } },
				{ key: 'min_price', name: 'M.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'b_price', name: 'B.Price', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull' },
				{ key: 'cost', name: 'Cost', tbl_width: '65px', td_class: ['al_right'], display_filter: 'toCurrencyZeroNull', hidden: !this.cost_viewable },
				{ key: 'available_quantity', name: 'Avail', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'total_bo_quantity', name: 'B/O', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'on_board_quantity', name: 'On Board', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'po_quantity', name: 'On Order', tbl_width: '65px', td_class: ['al_right'], click_event: 'onOrderClick', display_filter: 'commaSeparated' },
				// { key: 'total_quantity', name: 'Avail + On Board + On Order', tbl_width: '100px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'total_quantity', name: 'Avail + On Order', tbl_width: '100px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'pending_30_quantity', name: 'Pend30', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'avg_5ms_quantity', name: '5 M Avg', tbl_width: '65px', td_class: ['al_right', 'red_letter'], display_filter: 'commaSeparated' },
				{ key: 'thisMonthSales', name: 'C Month', tbl_width: '60px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'ms1', name: '1M', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'ms2', name: '2M', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'ms3', name: '3M', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'ms4', name: '4M', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'ms5', name: '5M', tbl_width: '65px', td_class: ['al_right'], display_filter: 'commaSeparated' },
				{ key: 'arrival_date', name: 'Arr Date', tbl_width: '80px', td_class: ['al_left'] },
			];
			if (this.user.company_id == 'newjigu') {
				header.splice(0, 0, { key: 'group_name', name: this.headers.class + ' Group', tbl_width: '90px', td_class: ['al_left', 'truncate'], title: { prop: 'group_name' } });
			}

			return header;
		},
		setHeader() {
			if (this.is_sales_status) this.tbl_headers = this.salesStatusHeader();
			else if (this.isMinkHair) this.tbl_headers = this.minkhairHeader();
			else if (this.isNewjigu) this.tbl_headers = this.newjiguHeader();
			else this.tbl_headers = this.defaultHeader();
		},
	},
	created() {
		this.page_size = this.$store.getters['getDefaultPageSize'];

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory_status');
		this.$store.commit('setSubTitle', 'Item -> Inventory Status');

		this.setHeader();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
